var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 74,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-38.205%",
    y1: "-568.076%",
    x2: "50%",
    y2: "1024.513%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52DEFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5144FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-164 -1260)",
    fill: "url(#a)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.347 1265.313H208.99c-1.454 0-2.633-1.19-2.633-2.657a2.645 2.645 0 0 1 2.633-2.655h47.357a2.645 2.645 0 0 1 2.634 2.655c0 1.467-1.18 2.657-2.634 2.657M256.347 1283.373h-29.833c-1.455 0-2.633-1.19-2.633-2.656 0-1.467 1.178-2.656 2.633-2.656h29.833a2.645 2.645 0 0 1 2.634 2.656c0 1.467-1.18 2.656-2.634 2.656M254.77 1301.434h-20.267c-1.454 0-2.634-1.19-2.634-2.656a2.645 2.645 0 0 1 2.634-2.656h20.267a2.645 2.645 0 0 1 2.634 2.656c0 1.467-1.18 2.656-2.634 2.656M208.138 1321.54c-10.585 8.87-26.323 8.3-36.246-1.71-10.522-10.614-10.522-27.822 0-38.436s27.583-10.614 38.105 0c9.605 9.686 10.443 24.868 2.516 35.515l10.86 10.955a3.204 3.204 0 0 1-.007 4.516 3.158 3.158 0 0 1-4.475.007l-10.753-10.846zm-1.737-5.337c8.536-8.61 8.536-22.57 0-31.18s-22.375-8.61-30.911 0c-8.536 8.61-8.536 22.57 0 31.18s22.375 8.61 30.91 0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e8ab93de22d470d99f73152fed7349f1.svg";
export { ForwardRef as ReactComponent };